// Persona do autor dos conteúdos (E-E-A-T).
// FICTÍCIO por enquanto — trocar pelos dados reais quando definidos.

export interface Author {
  slug: string;
  name: string;
  /** Cargo exibido (ex: "Idealizador · Vem Pra Ilha do Mel"). */
  role: string;
  /** Cargo "puro" para o schema Person.jobTitle (ex: "Idealizador"). */
  jobTitle: string;
  /** Caminho da foto (quadrada). Se ausente, mostra as iniciais. */
  photo?: string;
  initials: string;
  bio: string;
  /** Linha curta de experiência/vivência (sinal de E-E-A-T). */
  experienceLine: string;
  /** Áreas de expertise → badges (UI). */
  expertise: string[];
  /** Tópicos de autoridade para o schema Person.knowsAbout (E-E-A-T). */
  knowsAbout: string[];
  social: {
    instagram?: string;
    whatsapp?: string;
    email?: string;
  };
  /** Perfis públicos do autor para Person.sameAs. */
  sameAs: string[];
  /** Página de autor (bio completa + lista de textos). Opcional. */
  profileUrl?: string;
}

export const defaultAuthor: Author = {
  slug: 'matheus-almeida',
  name: 'Matheus Almeida',
  role: 'Idealizador · Vem Pra Ilha do Mel',
  jobTitle: 'Idealizador',
  photo: '/images/autores/matheus-almeida.jpg',
  initials: 'MA',
  bio: 'Passei anos no marketing digital, com empresas de IA e SaaS B2B, até resolver dar uma pausa e morar neste lugar que me encantou desde o primeiro dia. Hoje minha vida é conhecer cada canto da Ilha do Mel e compartilhar tudo com vocês.',
  experienceLine: '1 ano morando na Ilha do Mel · todas as praias visitadas a pé',
  expertise: [],
  knowsAbout: [
    'Ilha do Mel',
    'Praias da Ilha do Mel',
    'Turismo na Ilha do Mel',
    'Trilhas da Ilha do Mel',
    'Encantadas',
    'Nova Brasília',
    'Litoral do Paraná',
    'Marés e travessia de barco',
  ],
  social: {},
  sameAs: [],
  // profileUrl: '/autor/matheus-almeida', // reativar quando a página de autor existir
};
